var _defs, _g, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeBannerWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fbf7f4;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #e0e9ee;\n      }\n\n      .cls-3 {\n        fill: #ccdae3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1080.55 778.02 1080.55 719.73 1002.34 719.73 1002.34 664.95 930.44 664.95 930.44 609.82 844.67 609.82 844.67 565.93 758.47 565.93 758.47 946.22 844.25 946.22 844.67 946.22 930.02 946.22 930.44 946.22 1002.34 946.22 1080.55 946.22 1163.81 946.22 1163.81 778.02 1080.55 778.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-134.18,53v1027h2188.35V53H-134.18ZM1155.27,879.28c0,6.8-3.02,12.56-7.07,14.22h-336.96c-5.23,0-9.5-6.61-9.5-14.71v-416.25c0-170.51,46.16-300.12,173.57-319.35,81.83,11.79,179.96,80.73,179.96,319.85v416.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1148.2,893.54c-.77.31-1.58.49-2.43.49h-396.59c-5.23,0-9.5-6.61-9.5-14.71v-416.23c0-185,54.33-321.84,207.79-321.84,8.93,0,18.26.6,27.83,1.99-127.41,19.23-173.57,148.84-173.57,319.35v416.25c0,8.09,4.27,14.71,9.5,14.71h336.96Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1920,
    height: 52.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 955,
    width: 1920,
    height: 125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBannerWall);
export default __webpack_public_path__ + "static/media/home-banner-wall.acfcabaae5e3866f7a6abab16c3cee8a.svg";
export { ForwardRef as ReactComponent };